export const aciServiceRoom = {
    iconName: 'service-room',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M9.14 4.47c0-.26.211-.47.471-.47h5.206a.47.47 0 110 .941H9.61a.47.47 0 01-.47-.47zM2.89 19.53c0-.26.211-.471.471-.471h17.716a.47.47 0 010 .94H3.361a.47.47 0 01-.47-.47zM11.214 7.324c.277-.192.628-.3 1.056-.3.428 0 .78.109 1.06.296.277.186.455.43.569.66.103.207.157.41.186.566a18.45 18.45 0 011.421.64c.95.478 2.149 1.185 3.073 2.088.945.923 1.547 2.11 1.92 3.197.374 1.088.528 2.11.555 2.736a.47.47 0 01-.47.49H3.857a.47.47 0 01-.468-.52c.14-1.307.444-3.576 2.34-5.866.972-1.173 2.265-1.892 3.293-2.317a10.934 10.934 0 011.493-.495c.025-.145.07-.322.15-.503.105-.233.275-.482.55-.672zm-.176 2.023h-.004l-.022.005c-.02.003-.05.01-.09.019-.08.017-.2.045-.35.086a9.99 9.99 0 00-1.19.407c-.953.393-2.092 1.038-2.928 2.047-1.496 1.807-1.9 3.59-2.067 4.845H20.07a10.033 10.033 0 00-.462-1.98c-.344-1.003-.883-2.043-1.687-2.828-.824-.805-1.924-1.46-2.839-1.92a17.508 17.508 0 00-1.564-.692l-.022-.007-.005-.002a.47.47 0 01-.313-.44v-.004a1.262 1.262 0 00-.123-.485.747.747 0 00-.25-.296c-.109-.073-.274-.137-.536-.137s-.42.064-.52.133a.667.667 0 00-.226.284 1.184 1.184 0 00-.098.453V8.864v-.002.002a.47.47 0 01-.387.482zm2.142-.463zm.47 0h-.47.47z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M10.79 11.039a.47.47 0 01-.225.627c-.495.234-1.596.842-2.165 1.423-.573.585-1.23 1.758-1.491 2.29a.47.47 0 01-.845-.414c.265-.54.977-1.834 1.664-2.535.692-.707 1.922-1.373 2.435-1.615a.47.47 0 01.626.224z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
